import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './routes/Routes';
import { store } from './store/store';


function App() {
 
  return (
    <div className=" ">
      <Provider store={store}>
       <RouterProvider router={router} />
      </Provider>
    </div>
  );
}

export default App;
